var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","height":"100%"}},[_c('simple-table',[_c('thead',[_c('AmountTableRow',{attrs:{"name":"Total Received","amount":_vm.total,"bold":"","mandatory":""}})],1),_c('tbody',_vm._l((_vm.charges),function(item,index){return _c('AmountTableRow',{key:index,attrs:{"name":item.title,"amount":item.amount}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }